import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SchoolIcon from "@mui/icons-material/School";
import ChecklistIcon from "@mui/icons-material/Checklist";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ClassIcon from "@mui/icons-material/Class";
import {
  CandidateServicePath,
  CANDIDACIES,
  CampaignSubTypes,
  EnrollmentFormType,
  StudentServicePath,
  STUDY_GROUPS,
  PREPARATORY_YEARS,
  CANDIDATES,
} from "utils/constants";

import permissions from "app/permissions";
import ListAcceptedStudents from "./StudentsEnrollment/List";
import { resources as ApprovedDoctorantCandidacies } from "components/Doctoral/ApprovedCandidacies";
import OthersOptions from "./StudentsEnrollment/OthersOptions";
import CreateEnrollmentForm from "./StudentsEnrollment/CreateTemplate";
import { tenants } from "utils/tenants";
import ListUnallocated from "./Unallocated/List";
import CreatePreparatoryForm from "./Preparatory/CreatePreparatoryForm";
import ListAcceptedPreparatory from "./Preparatory/List";
import { resources as SpecialistsEnrollment } from "./SpecialistsEnrollment";
import { resources as EnrollSpecialist } from "./SpecialistsEnrollment/EnrollSpecialist";

export const resources = {
  tenancies: [tenants.MU, tenants.MGU],
  isMenu: true,
  icon: <SchoolIcon />,
  name: CandidateServicePath + CANDIDACIES,
  title: "Записване",
  subMenu: [
    {
      isMenu: true,
      tenancies: [tenants.MU],
      icon: <CheckCircleIcon />,
      name: "candidate/approved",
      custom: <ListAcceptedStudents campaignSubType={CampaignSubTypes.Regular} />,
      title: "Приети КСК",
      permission: permissions.canEnrollCandidates,
    },
    {
      isMenu: false,
      tenancies: [tenants.MU],
      custom: (
        <CreateEnrollmentForm
          title="Записване на студент - Приети КСК"
          isKSK={true}
          isIndividual={false}
          isOther={false}
        />
      ),
      name: "candidate/ksk",
      permission: permissions.canEnrollCandidates,
    },
    {
      tenancies: [tenants.MU, tenants.MGU],
      isMenu: true,
      icon: <ChecklistIcon />,
      name: "candidate/others",
      custom: <OthersOptions campaignSubType={CampaignSubTypes.Regular} />,
      title: "Приети други",
      permission: permissions.canPreviewCandidacies,
    },
    {
      isMenu: false,
      tenancies: [tenants.MU, tenants.MGU],
      custom: (
        <CreateEnrollmentForm
          title={"Записване на студент прехвърлен от друг университет - Българи"}
          resource={`candidate/candidate-enrollments?formType=${EnrollmentFormType.OtherUniversity}`}
          isIndividual={false}
          isOther={true}
          isKSK={false}
          isPms={false}
        />
      ),
      name: "/candidate/bg/other-uni",
      permission: permissions.canPreviewCandidacies,
    },
    {
      isMenu: false,
      tenancies: [tenants.MU],
      custom: (
        <CreateEnrollmentForm
          title={"Записване на студент прехвърлен от друг университет - Чужденци"}
          resource={`candidate/candidate-enrollments?formType=${EnrollmentFormType.OtherUniversity}`}
          isIndividual={false}
          isOther={true}
          isKSK={false}
          isPms={false}
        />
      ),
      name: "/candidate/en/other-uni",
      permission: permissions.canPreviewCandidacies,
    },
    {
      isMenu: false,
      tenancies: [tenants.MU, tenants.MGU],
      custom: (
        <CreateEnrollmentForm
          title={"Записване на студент с индивидуална заповед - Българи"}
          isIndividual={true}
          isOther={false}
          isKSK={false}
          isPms={false}
          //s prowerka na egn
          resource={`candidate/candidate-enrollments?formType=${EnrollmentFormType.IndividualOrder}`}
        />
      ),
      name: "candidate/bg/individual",
      permission: permissions.canPreviewCandidacies,
    },
    {
      isMenu: false,
      tenancies: [tenants.MU],
      custom: (
        <CreateEnrollmentForm
          title={"Записване на студент с индивидуална заповед - Чужденци"}
          isIndividual={true}
          isOther={false}
          isKSK={false}
          isPms={false}
          //s prowerka na egn
          resource={`candidate/candidate-enrollments?formType=${EnrollmentFormType.IndividualOrder}`}
        />
      ),
      name: "candidate/en/individual",
      permission: permissions.canPreviewCandidacies,
    },
    {
      isMenu: false,
      tenancies: [tenants.MU],
      custom: (
        <CreateEnrollmentForm
          isIndividual={false}
          isOther={false}
          isKSK={false}
          isPms={true}
          title={"Записване на студент По ПМС 103 или 228 - Българи"}
          resource={`candidate/candidate-enrollments?formType=${EnrollmentFormType.Pms}`}
        />
      ),
      name: "candidate/bg/pms",
      permission: permissions.canPreviewCandidacies,
    },
    {
      isMenu: false,
      tenancies: [tenants.MU],
      custom: (
        <CreateEnrollmentForm
          isIndividual={false}
          isOther={false}
          isKSK={false}
          isPms={true}
          title={"Записване на студент По ПМС 103 или 228 - Чужденци"}
          resource={`candidate/candidate-enrollments?formType=${EnrollmentFormType.Pms}`}
        />
      ),
      name: "candidate/en/pms",
      permission: permissions.canPreviewCandidacies,
    },
    {
      isMenu: true,
      tenancies: [tenants.MU],
      icon: <PersonAddIcon />,
      name: `${StudentServicePath}${STUDY_GROUPS}/students/unassigned`,
      list: <ListUnallocated />,
      title: "Неразпределени студенти",
      permission: permissions.canPreviewUnassignedStudyGroupStudents,
    },
    {
      isMenu: true,
      tenancies: [tenants.MU],
      icon: <ClassIcon />,
      name: `${CandidateServicePath}${PREPARATORY_YEARS}-${CANDIDATES}`,
      list: <ListAcceptedPreparatory />,
      title: "Подготвителна година",
      permission: permissions.canPreviewPreparatoryYearCandidates,
    },
    {
      isMenu: false,
      tenancies: [tenants.MU],
      custom: <CreatePreparatoryForm title="Записване на студент - Подготвителна година" />,
      name: "candidate/preparatory-deos",
      permission: permissions.canEnrollPreparatoryYearCandidates,
    },
    SpecialistsEnrollment,
    EnrollSpecialist,
    ApprovedDoctorantCandidacies,
  ],
};
